import { projects } from "../constants";
import "../styles/projects.css";
import ProjectBoard from './ProjectBoard';
import { HiOutlinePlus } from "react-icons/hi";

const Projects = () => {
	return (
		<div className="projects">
			<h1><b>Projects</b></h1>
			<div className="created-projects">
				<p>You have {projects.length} project(s) created</p>
				<div className="created-project-list">
					{projects.map((project, i) => {
						return (
							<div className="project" key={i}>
								<div className="project-items">
									{project.items.map((item, j) => {
										return <img src={item} key={j} />;
									})}
								</div>
								<h2>{project.title}</h2>
								<div className="view-project">
									<img src="/preview.png" />
									<p>View Project</p>
								</div>
							</div>
						);
					})}
					<div className="project new-project">
						<div className='add-filler'>
							<HiOutlinePlus />
						</div>
						<h2>Create New Project</h2>
					</div>
				</div>
			</div>
			<ProjectBoard/>
		</div>
	);
};

export default Projects;
